/**
 * Block types a v2 email document can contain. `columns` is the only container and may
 * hold any leaf type (never another `columns`). Order-scoped blocks (`orderItemTable`,
 * `shipTo`, `orderDetails`, `customMessage`) render nothing on templates without an order.
 */
enum EmailBlockTypeEnum {
    HEADING = "heading",
    TEXT = "text",
    IMAGE = "image",
    LOGO = "logo",
    BUTTON = "button",
    DIVIDER = "divider",
    SPACER = "spacer",
    COLUMNS = "columns",
    ORDER_ITEM_TABLE = "orderItemTable",
    SHIP_TO = "shipTo",
    ORDER_DETAILS = "orderDetails",
    CUSTOM_MESSAGE = "customMessage",
    FOOTER = "footer",
}

export default EmailBlockTypeEnum;
